import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { NPOSignupForm } from "@/components/NPOSignupForm";
import { HostSignupForm } from "@/components/HostSignupForm";
import { CorporateSignupForm } from "@/components/CorporateSignupForm";
import { AnonProfileForm } from "@/components/anon/AnonProfileForm";
import { DollarSign, CreditCard, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ProfilePage({
  profile,
  session,
}: {
  profile: any;
  session: any;
}) {
  const navigate = useNavigate();

  const handleNavigateToPayments = () => {
    navigate("/dashboard/payments");
  };

  const handleNavigateToSubscription = () => {
    navigate("/dashboard/subscription");
  };

  const handleNavigateToUsers = () => {
    navigate("/dashboard/users");
  };

  if (!profile) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-4xl font-bold tracking-tight">Profile</h2>
        {(profile.user_type === "nonprofit" ||
          profile.user_type === "host") && (
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              className="flex items-center gap-2"
              onClick={handleNavigateToUsers}
            >
              <UserPlus className="h-4 w-4" />
              Manage Users
            </Button>
            <Button
              variant="outline"
              className="flex items-center gap-2"
              onClick={handleNavigateToPayments}
            >
              <DollarSign className="h-4 w-4" />
              Manage Payouts
            </Button>
            {profile.user_type === "nonprofit" && (
              <Button
                variant="outline"
                className="flex items-center gap-2"
                onClick={handleNavigateToSubscription}
              >
                <CreditCard className="h-4 w-4" />
                Manage Subscription
              </Button>
            )}
          </div>
        )}
        {profile.user_type === "company" && (
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              className="flex items-center gap-2"
              onClick={handleNavigateToUsers}
            >
              <UserPlus className="h-4 w-4" />
              Manage Users
            </Button>
          </div>
        )}
      </div>
      <Card>
        <CardContent className="pt-6">
          {profile.user_type === "company" && (
            <CorporateSignupForm session={session} profile={profile} />
          )}
          {profile.user_type === "nonprofit" && (
            <NPOSignupForm session={session} profile={profile} />
          )}
          {profile.user_type === "host" && (
            <HostSignupForm session={session} profile={profile} />
          )}
          {profile.user_type === "anon" && (
            <AnonProfileForm session={session} profile={profile} />
          )}
          {!profile.user_type && (
            <div className="p-4 border border-yellow-300 bg-yellow-50 rounded-md">
              <h3 className="font-medium text-yellow-800">
                Profile Setup Required
              </h3>
              <p className="text-yellow-700 mt-1">
                Your user type is not set. Please check your account settings or
                contact support.
                <pre className="mt-2 p-2 bg-gray-100 rounded text-xs overflow-auto">
                  {JSON.stringify(profile, null, 2)}
                </pre>
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
